import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { ForumHeaderPortal } from '../components/ForumHeaderPortal';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['forum']);

  return (
    <Container>
      <ForumHeaderPortal>
        <Header.Root>
          <Header.Content backTo={routes.forumTimeline} title={t('forum:post.error.title')} />
        </Header.Root>
      </ForumHeaderPortal>

      <ErrorState onRetry={() => window.location.reload()} title={t('forum:post.error.title')} />
    </Container>
  );
};
